import { useUpsertIncidentStatusSummary } from 'components/IAP/hooks/incidentStatusSummaryHooks';

import EditableListTable from './EditableListTable';

type CommandPriorityRow = { commandPriority: string };

const CommandPrioritiesTable = ({
  statusSummaryId,
  originalCommandPriorities = [],
  readOnly = false,
}: {
  statusSummaryId: string;
  originalCommandPriorities?: CommandPriorityRow[];
  readOnly?: boolean;
}) => {
  const upsertIncidentStatusSummary =
    useUpsertIncidentStatusSummary(statusSummaryId);

  return (
    <EditableListTable<CommandPriorityRow>
      itemsLabel="command priorities"
      itemLabel="Command Priority"
      testId="ics209-command-priorities"
      columns={[{ key: 'commandPriority', label: 'Command Priority' }]}
      blank={{ commandPriority: '' }}
      primaryKey="commandPriority"
      values={originalCommandPriorities}
      readOnly={readOnly}
      onChange={(rows) =>
        upsertIncidentStatusSummary({
          commandPriorities: rows.map((row) => row.commandPriority),
        })
      }
    />
  );
};

export default CommandPrioritiesTable;
